import { arkScope } from '@/api/workspace/endpoints/arkConfig.ts';
import type { FxSwapNds } from '@/store/swap/state.ts';

export const SavedSwapNdsValidator = arkScope.type({
  type: "'FxSwap'",
  properties: {
    'currencyPair?': 'string',
    'nearNotional?': 'number',
    'farNotional?': 'number',
    currencyIndex: arkScope.type('CurrencyChoice').default(1),
    'nearExpiryDateTenor?': 'string',
    'farExpiryDateTenor?': 'string',
  },
  tileId: 'string',
  isNonDeliverable: 'true',
  'clientId?': 'number',
});

export type SavedSwapNds = typeof SavedSwapNdsValidator.infer;

export const SavedSwapNds = {
  fromFxSwapNds: (x: FxSwapNds, tileId: string): SavedSwapNds => ({
    type: 'FxSwap',
    isNonDeliverable: true,
    properties: {
      currencyPair: x.properties.currencyPair,
      nearNotional: x.properties.nearNotional,
      farNotional: x.properties.farNotional,
      currencyIndex: x.properties.nearNotionalCurrencyIndex ?? 1,
      nearExpiryDateTenor: x.properties.nearExpiryDateTenor,
      farExpiryDateTenor: x.properties.farExpiryDateTenor,
    },
    tileId,
    clientId: x.clientId,
  }),
} as const;
